import {Mapper} from '@s-ui/domain'

export class FromUseCaseParamsToGetLoanCalculationsTransactionsRequestMapper extends Mapper {
  constructor({getLoanCalculationsTransactionsRequestFactory}) {
    super()
    this._getLoanCalculationsTransactionsRequestFactory = getLoanCalculationsTransactionsRequestFactory
  }

  map = params => {
    const {carPlateRegistrationDate: plateRegistrationDate, lender, openingFee: entry, price, terms} = params

    return this._getLoanCalculationsTransactionsRequestFactory({
      entry,
      lender,
      plateRegistrationDate,
      price,
      terms
    })
  }
}
